import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
    paragraphContainer: {
        width: '100%',
    },
    paragraphOptions: {
        flexDirection: 'row',
        marginLeft: 0,
        marginRight: 20
    },
    optionButton: {
        marginRight: 20 ,
        marginTop: 15 ,
        marginBottom: 15 
    },
    text: {
        fontFamily: 'Lato_400Regular',
    },
    boldText: {
        fontFamily: 'Lato_700Bold',
    },
});

export default styles;